/**
 * Whether an event happened inside the widget's own UI.
 *
 * Checks the composed path rather than `event.target`: in the script-tag build
 * the widget sits in a Shadow DOM, and a listener on `document` sees every
 * event from inside it retargeted to the shadow host, so
 * `target.closest('[data-markup-widget]')` never matched there.
 */
export function isFromWidget(event: Event): boolean {
  return event.composedPath().some(
    (node) =>
      node instanceof Element &&
      (node.hasAttribute('data-markup-widget') ||
        node.hasAttribute('data-markup-widget-root') ||
        node.classList.contains('markup-widget-scope'))
  );
}
